import { render, staticRenderFns } from "./band.vue?vue&type=template&id=86f36624&scoped=true"
import script from "./band.vue?vue&type=script&lang=js"
export * from "./band.vue?vue&type=script&lang=js"
import style0 from "./band.vue?vue&type=style&index=0&id=86f36624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f36624",
  null
  
)

export default component.exports